"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tWithBold = void 0;
const react_1 = __importDefault(require("react"));
const is_defined_1 = require("../is-defined");
const i18n_1 = require("./i18n");
/**
 * Interpolated in place of a value so it can be found again in the translated sentence and
 * set apart from it. A control character, because it cannot occur in any translation — and
 * it survives i18next's escaping untouched.
 */
const MARK = '\u0000';
/**
 * A translated sentence with its interpolated values wrapped in `<strong>`, for the common
 * case of a design that sets a name, an address or a number apart from the copy around it.
 *
 * ```tsx
 * <p>{tWithBold('AUTH_OTP_SENT_TO_X', { x: email })}</p>
 * ```
 *
 * `t()` can only interpolate strings, so each value goes in as `\0name\0` and the result is
 * split back apart on the marker. Splitting rather than a fixed order on purpose: a
 * translation may name the values in any order, or repeat one, and this does not care.
 *
 * Values are rendered as React children, so nothing is interpolated into markup and the
 * translation itself is never treated as HTML — unlike `dangerouslySetInnerHTML`, which is
 * the other way to get a bold word out of one key.
 *
 * A missing key means `t()` answers with the key name — no markers, one plain part. An
 * `undefined` value renders as nothing, as it would anywhere else in JSX.
 */
const tWithBold = (key, values) => {
    const marked = Object.fromEntries(Object.keys(values).map((name) => [name, `${MARK}${name}${MARK}`]));
    return String((0, i18n_1.t)(key, marked))
        .split(MARK)
        .map((part, index) => (0, is_defined_1.isDefined)(values[part]) ? (react_1.default.createElement("strong", { key: index }, values[part])) : (react_1.default.createElement(react_1.default.Fragment, { key: index }, part)));
};
exports.tWithBold = tWithBold;
